import axiosInstance from './../providers/Axios';

import { getProducts } from '../config/paths';

export const callGetProducts = async (dni) => {
  return axiosInstance({
    url: `${getProducts}/${dni}`,
    method: 'get',
    params: {},
  });
};
